import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.nav`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  min-width: 0;
`

export const BackLabel = styled(Text)`
  color: ${props => props.theme.colors.text.subtle};
`

export const BackLink = styled.button`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  color: ${props => props.theme.colors.text.subtle};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colors.primary.hover};

    ${BackLabel} {
      color: ${props => props.theme.colors.primary.hover};
    }
  }
`

export const Separator = styled(Text)`
  flex-shrink: 0;
  color: ${props => props.theme.colors.text.subtle};
`

export const CurrentLabel = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
